<a *ngIf="item?.value" [href]="'/external/' + item.value.course+'/display?display=borderless&amp;url='+item.value.url+'&lms='+item.value.lms" target="_blank">{{item.value.title || item.value.test}}</a>
<p-select ngDefaultControl [options]="tools" [(ngModel)]="tool" placeholder="Select Tool" [disabled]="checkDisable()" (change)="select($event)" optionLabel="title"
 />

<button pButton (click)="launch()" [disabled]="!tool" *ngIf="!checkDisable() && resource">{{'setup'| translation}}</button>
<input pInputText type="text" [(ngModel)]="tool_def.url" (input)="inputUpdated()" />
<p-checkbox binary="true" inputId="tool_def_new_tab" [(ngModel)]="tool_def.new_tab" [name]="tool_def.new_tab" ngDefaultControl [disabled]="checkDisable()" (onChange)="inputUpdated()" >
</p-checkbox>
<label for="tool_def_new_tab">{{'open_new_tab'| translation}}</label>
